import React from "react";
import DeclineOverlay from "./DeclineOverlay";
import UndoOverlay from "./UndoOverlay";
import { Link } from "react-router-dom";
import {
  formatDateYearSmall,
  formatDateMedium
} from "../../../../../utils/dates";
import messagesIcon from "../../../../../assets/images/speech-bubble.svg";
import styles from "./Pitch.scss";

class Pitch extends React.Component {
  static defaultProps = {
    declined: false
  };

  state = {
    declining: false,
    undoing: false
  };

  decline = () => {
    this.setState({
      ...this.state,
      declining: true
    });
  };

  confirmDecline = message => {
    const { onDecline, id } = this.props;

    this.setState({
      ...this.state,
      declining: false
    });

    onDecline(id, message);
  };

  cancelDecline = () => {
    this.setState({
      ...this.state,
      declining: false
    });
  };

  undo = () => {
    this.setState({
      ...this.state,
      undoing: true
    });
  };

  confirmUndo = () => {
    const { id, onUndo } = this.props;

    this.setState({
      ...this.state,
      undoing: false
    });

    onUndo(id);
  };

  cancelUndo = () => {
    this.setState({
      ...this.state,
      undoing: false
    });
  };

  renderMatches(id, match) {
    const { matched_on } = this.props;

    const filtered = matched_on.slice(0, 5);

    return (
      <ul>
        {filtered.map((match, key) => (
          <li key={key}>{match.name}</li>
        ))}
        {matched_on.length > 5 && (
          <Link
            to={`/company/pitch/${id}/member/${match.member_id}/project/${
              match.project_id
            }/memberProfile`}
          >
            <li>{`+${matched_on.length - 5} other skills`}</li>
          </Link>
        )}
      </ul>
    );
  }

  renderFragment() {
    const { accepted, updated_at, id, messages, match } = this.props;

    if (_.isUndefined(accepted) || _.isNull(accepted) || accepted) {
      // Pitched
      if (!messages) return null;
      let messagesCount = messages.length;
      if (messagesCount < 10) {
        messagesCount = "0" + messagesCount;
      }
      return (
        <React.Fragment>
          <Link
            to={`/company/pitch/${id}/member/${match.member_id}/project/${
              match.project_id
            }/messages`}
            className={styles.messages}
          >
            <img
              src={messagesIcon}
              alt="Messages"
              className={styles.messagesImage}
            />
            <span className={styles.messagesText}>{messagesCount}</span>
          </Link>
          <button
            title="Decline Pitch"
            type="button"
            className={styles.decline}
            onClick={this.decline}
          />
        </React.Fragment>
      );
    } else {
      // Declined by employer
      return (
        <React.Fragment>
          <span className={styles.declinedOn}>
            Declined on {formatDateYearSmall(updated_at)}
          </span>
          <button
            type="button"
            className={styles.undo}
            onClick={this.undo}
            title="Undo Decline"
          />
        </React.Fragment>
      );
    }
  }

  render() {
    const { pitch, created_at, match, matched_on, declined, id } = this.props;

    const { declining, undoing } = this.state;

    const { pitch: pitchElement } = this.refs;

    if (pitchElement && pitch) {
      pitchElement.innerHTML = pitch;
    }

    return (
      <section className={`${styles.pitch} ${declined && styles.declined}`}>
        {declining && (
          <DeclineOverlay
            name={match.member.first_name + " " + match.member.last_name}
            onCancel={this.cancelDecline}
            onConfirm={this.confirmDecline}
          />
        )}
        {undoing && (
          <UndoOverlay
            onCancel={this.cancelUndo}
            onConfirm={this.confirmUndo}
          />
        )}

        <div className={styles.header}>
          <div className={styles.name}>
            <Link
              to={`/company/pitch/${id}/member/${match.member_id}/project/${
                match.project_id
              }/memberProfile`}
            >
              {match.member.first_name + " " + match.member.last_name}
            </Link>
          </div>

          {this.renderFragment()}
        </div>
        <div className={styles.body}>
          <div className={styles.details}>
            <h4>The Pitch</h4>
            <span className={styles.date}>{formatDateMedium(created_at)}</span>
            <div className={styles.message}>
              <div ref="pitch" />
              <Link
                to={`/company/pitch/${id}/member/${match.member_id}/project/${
                  match.project_id
                }/messages`}
              >
                Respond to this pitch &rsaquo;
              </Link>
            </div>
          </div>
          <div className={styles.matches}>
            <h4>Matched On</h4>

            {matched_on &&
              matched_on.length > 0 &&
              this.renderMatches(id, match)}
          </div>
        </div>
      </section>
    );
  }
}

export default Pitch;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/candidates/Pitch.js